import React from "react";
import PropTypes from "prop-types";
import Session from "../../../components/adm/session/sessionForm";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const SessionFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Session uuid={uuid} />} />;
};

SessionFormPage.propTypes = {};

export default SessionFormPage;
